import React, { useEffect, useCallback, useState } from 'react';

import debounce from 'lodash.debounce';
import { PromiseState } from 'react-refetch';

import useMedia from 'hooks/useMedia';
import apiConnect from 'helpers/apiConnect';

import TextBlock from './components/TextBlock';
import TableBlock from './components/TableBlock';

import getPlaylistTableURL from 'url-constructors/getPlaylistTableURL';

import {
  Container,
  FAQActivityTrackerBlockWrapper,
} from '../FAQActivityTracker.styles';

interface IFAQActivityTrackerBlockProps {
  playlistData: PromiseState<any>;
  fetchPlaylistData: Function;
}

const dataSource = (): any => {
  return {
    fetchPlaylistData: (props: any): any => {
      return {
        playlistData: getPlaylistTableURL(props),
      };
    },
  };
};

const FAQActivityTrackerBlock: React.FC<IFAQActivityTrackerBlockProps> = (
  props
) => {
  const { playlistData = PromiseState.create(), fetchPlaylistData } = props;
  const isMobileView = useMedia('(max-width: 50em)');
  const [searchInputValue, setSearchInputValue] = useState<string>('');
  const [searchQuery, setSearchQuery] = useState<string>('');

  useEffect(() => {
    fetchPlaylistData({
      isTopList: true, // to fetch all playlists
      playlistType: 'priority',
      limit: 999,
      nameFilter: searchQuery,
    });
  }, [fetchPlaylistData, searchQuery]);

  const { fulfilled, pending, reason, value } = playlistData;

  /**
   * Debounced search query setter
   */
  const doSearchQuery = useCallback(
    debounce((str: string) => setSearchQuery(str), 250),
    []
  );

  /**
   * Handler for both setting the search input contents and doing a debounced search query.
   */
  const handleSearchInput = useCallback(
    (evt) => {
      const value = evt.target.value;
      setSearchInputValue(value);
      doSearchQuery(value);
    },
    [doSearchQuery]
  );

  const showNoResults =
    fulfilled &&
    searchQuery &&
    (value?.playlists?.length === 0 || !value?.playlists);

  return (
    <Container isMobileView={isMobileView}>
      <FAQActivityTrackerBlockWrapper isMobileView={isMobileView}>
        <TextBlock />
        <TableBlock
          isMobileView={isMobileView}
          data={value?.playlists}
          isLoading={pending}
          error={reason}
          searchInputValue={searchInputValue}
          handleSearchInput={handleSearchInput}
          showNoResults={!!showNoResults}
        />
      </FAQActivityTrackerBlockWrapper>
    </Container>
  );
};

export default apiConnect(dataSource)(FAQActivityTrackerBlock as any);
